module.exports = __webpack_public_path__ + "images/tips/webinars-1@2x.f1f39fe1384c4439d932.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/webinars-1@2x.png
// module id = 4IU/
// module chunks = 1